'use client'

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/react-splide/css'
import '@/public/css/splide-custom.css'

const testimonials = [
    {
        text: 'I needed to send out several important documents while traveling overseas and had no access to a printer or local mail service. This website saved me! Within minutes, I uploaded my files, entered the addresses, and they handled everything—from printing to mailing. My letters arrived on time, and I got tracking updates along the way. It’s now my go-to solution for all business and personal mailings. Highly recommend!',
        author: 'Jessica M.',
        title: 'Freelance Consultant',
    },
    {
        text: 'As a small business owner, I used to spend hours printing, stuffing, and mailing client letters. Since I started using this remote mailing service, everything’s been streamlined. I just upload my documents, and they handle the rest—printing, postage, and mailing—without me ever leaving my desk. It saves me time, money, and hassle. Reliable, professional, and super easy to use!',
        author: 'David L.',
        title: 'Owner, BrightPath Financial Solutions',
    },
    {
        text: 'I was skeptical at first about using an online mailing service, but this platform exceeded my expectations. The interface is user-friendly, and the customer support team was incredibly helpful when I had questions. I sent out invitations for my wedding, and they arrived beautifully printed and on time. I’ll definitely be using this service again for future mailings!',
        author: 'Sarah K.',
        title: 'Bride-to-be',
    },
]

const TestimonialCarousel = () => {
    return (
        <>
            <Splide
                options={{
                    autoplay: true,
                    type: 'loop',
                    perPage: 1,
                    interval: 5000,
                    speed: 1500,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                }}
                hasTrack={false}
                aria-label="Testimonial Carousel"
                className="splide-controls-gray-on-transparent"
            >
                <div>
                    <SplideTrack>
                        {testimonials.map((testimonial, index) => (
                            <SplideSlide key={index}>
                                <div className="relative min-h-[400px]">
                                    <div className="slide-item-data flex size-full items-center justify-center px-16 md:px-20 h-full">
                                        <div className="slide-data-contents z-10 text-center font-maven-pro text-white">
                                            <div className="text-small sm:text-xl italic px-2 lg:px-32 pb-4 md:pb-10 leading-tight sm:leading-snug md:leading-loose text-[#2e2e30] dark:text-gray-400">
                                                <p>{testimonial.text}</p>
                                            </div>
                                            <p className="text-base font-montserrat text-[#95959b] dark:text-white">
                                                <span className="font-bold">
                                                    {testimonial.author}
                                                </span>
                                                , {testimonial.title}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))}
                    </SplideTrack>

                    <div className="splide__arrows">
                        <button className="splide__arrow splide__arrow--prev !w-[60px] md:!w-[80px]">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 40 40"
                                width="40"
                                height="40"
                            >
                                <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                            </svg>
                        </button>
                        <button className="splide__arrow splide__arrow--next !w-[60px] md:!w-[80px]">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 40 40"
                                width="40"
                                height="40"
                            >
                                <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </Splide>
        </>
    )
}

export default TestimonialCarousel
